import { DimensionUnit, WeightUnit } from '@invenco/common-interface/shared';
import { SkuType } from '@invenco/products-interface';

import type { SkusQueryQuery } from '@/graphql/generated/seller/graphql';
import { convertDateTimeToISO, getEnumValue } from '@/shared/helpers';
import { ListData } from '@/shared/types';

export type SkuListItem = {
  id: string;
  name: string;
  description: string;
  barcode: string;
  type?: SkuType;
  height?: number;
  width?: number;
  length?: number;
  dimensionUnit?: DimensionUnit;
  weight?: number;
  weightUnit?: WeightUnit;
  archivedAt?: string;
};

export class SkuListMapper {
  static toData(response: SkusQueryQuery): ListData<SkuListItem> {
    const total = response?.skusAggregate?._count ?? 0;
    const data = Array.isArray(response.skus)
      ? response.skus.map((sku) => ({
          id: sku.id,
          name: sku.name,
          description: sku.description,
          barcode: sku.barcode,
          // TODO: Remove KIT mapping once backend sends BUNDLE instead of KIT
          type: getEnumValue(SkuType, sku.type === 'KIT' ? 'BUNDLE' : sku.type),
          height: sku.height ?? undefined,
          width: sku.width ?? undefined,
          length: sku.length ?? undefined,
          dimensionUnit: sku.dimensionUnit
            ? getEnumValue(DimensionUnit, sku.dimensionUnit)
            : undefined,
          weight: sku.weight ?? undefined,
          weightUnit: sku.weightUnit ? getEnumValue(WeightUnit, sku.weightUnit) : undefined,
          archivedAt: sku.archivedAt ? convertDateTimeToISO(sku.archivedAt) : undefined,
        }))
      : [];

    return {
      data,
      total,
    };
  }
}
